/**
 * Format data to distriution dataset
 * @param {*} dataset
 * @returns
 */
export const formatIndicatorToDistributionDataset = dataset => {
  const items = dataset[dataset.sortBy]

  const distributionDataset = {
    items: [],
    unit: dataset.unit,
    dataType: dataset.dataType,
    dataValue: dataset.dataValue,
    distributionType: dataset.sortBy,
    start: dataset.start,
    end: dataset.end,
  }

  for (const key in items) {
    distributionDataset.items.push({
      category: key,
      count: items[key],
      percent:
        dataset.dataType !== 'percentage'
          ? Math.round((items[key] * 100) / dataset.value)
          : items[key],
    })
  }

  return distributionDataset
}
